import { SkinAttribute } from "./v1";
import { SkinAttributeV2 } from "./v2";

export const getSkinAttributeEnum = (version?: string) => {
	if (version == null) return SkinAttribute;
	return SkinAttributeV2;
};
